import { api, apiFormData } from './api';

// Enum para status do post (deve bater com o ENUM do banco)
export enum PostStatus {
  PUBLISHED = 'PUBLISHED',
  DRAFT = 'DRAFT',
  PENDING = 'PENDING',
}

export interface Post {
  id?: number;
  author_id?: number;
  category_id?: number;
  title: string;
  slug?: string;
  body?: string;
  summary?: string | null;
  image?: string;
  status: PostStatus | string;
  viewed?: number;
  featured?: boolean;
  published_at?: string;
  created_at?: string;
  updated_at?: string;
  categories?: Category[];
  category_ids?: number[];
  author?: {
    id: number;
    name: string;
  };
  meta_title?: string | null;
  meta_description?: string | null;
}

export interface Category {
  id: number;
  name: string;
  slug: string;
  description?: string;
  meta_title?: string | null;
  meta_description?: string | null;
  products_count?: number;
}

export interface BlogStats {
  total_posts: number;
  published_posts: number;
  total_views: number;
  drafts: number;
}

export const blogService = {
  // Admin Posts
  getAdminPosts: async (params?: {
    page?: number;
    search?: string;
    status?: string;
    category_id?: number;
    per_page?: number;
    month?: string;
    year?: string;
  }) => {
    // Remove undefined para não enviar parâmetros vazios
    const cleanParams: Record<string, any> = {};
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          cleanParams[key] = value;
        }
      });
    }
    const response = await api.get('/api/admin/blog/posts', { params: cleanParams });
    return response.data;
  },

  getAdminPostById: async (id: number | string) => {
    const response = await api.get(`/api/admin/blog/posts/${id}`);
    return response.data;
  },

  createPost: async (data: Partial<Post>) => {
    const response = await api.post('/api/admin/blog/posts', data);
    return response.data;
  },

  updatePost: async (id: number | string, data: Partial<Post>) => {
    const response = await api.put(`/api/admin/blog/posts/${id}`, data);
    return response.data;
  },

  deletePost: async (id: number | string) => {
    const response = await api.delete(`/api/admin/blog/posts/${id}`);
    return response.data;
  },

  getBlogStats: async () => {
    const response = await api.get('/api/admin/blog/stats');
    return response.data;
  },

  // Categories
  getCategories: async () => {
    const response = await api.get('/api/admin/blog/categories');
    return response.data;
  },

  createCategory: async (data: { name: string; description?: string }) => {
    const response = await api.post('/api/admin/blog/categories', data);
    return response.data;
  },

  updateCategory: async (id: number | string, data: { name: string; description?: string }) => {
    const response = await api.put(`/api/admin/blog/categories/${id}`, data);
    return response.data;
  },

  deleteCategory: async (id: number | string) => {
    const response = await api.delete(`/api/admin/blog/categories/${id}`);
    return response.data;
  },

  // Upload
  uploadImage: async (file: File, folder = 'blog') => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('folder', folder);

    const response = await apiFormData.post('/api/admin/upload/send', formData);
    return response.data;
  },
};
